import { dataConstants } from "../_constants";

let user = JSON.parse(localStorage.getItem("OLRToolsUser"));

const defaultState = {
  auctionHouseCompanies: {
    loading: false,
    items: [],
  },
  auctionHouseCompanies_item: {
    loading: false,
    data: {},
  },
  selectedCompany: {
    id: 0,
  },
};
const initialState = user
  ? {
      ...defaultState,
    }
  : defaultState;

export function data(state = initialState, action) {
  switch (action.type) {
    case dataConstants.DATA_GET_REQUEST:
      return {
        ...state,
        [action.model]: {
          ...state[action.model],
          loading: true,
        },
      };

    case dataConstants.DATA_GET_SUCCESS:
      return {
        ...state,
        [action.model]: {
          ...state[action.model],
          items: action.values.data,
          page: Number(action.values.current_page),
          per_page: Number(action.values.per_page),
          total: Number(action.values.total),
          loading: false,
        },
      };

    case dataConstants.DATA_GET_FAILURE:
      return {
        ...state,
        [action.model]: {
          ...state[action.model],
          loading: false,
        },
      };

    case dataConstants.DATA_GET_ONE_REQUEST:
      return {
        ...state,
        [action.model + "_item"]: {
          ...state[action.model + "_item"],
          loading: true,
        },
      };

    case dataConstants.DATA_GET_ONE_SUCCESS:
      return {
        ...state,
        [action.model + "_item"]: {
          ...state[action.model + "_item"],
          ...action.values,
          loading: false,
        },
      };

    case dataConstants.DATA_GET_ONE_FAILURE:
      return {
        ...state,
        [action.model + "_item"]: {
          ...state[action.model + "_item"],
          loading: false,
        },
      };

    case dataConstants.DATA_SELECTED_COMPANY:
      return {
        ...state,
        [action.model]: {
          ...state[action.model],
          loading: false,
        },
      };
    default:
      return state;
  }
}
